import apiPenghasilan from '@/api/seller/penghasilan';

const defaultState = () => ({
	saldo: null,
	saldoDepositResellerArr: null,
	depositResellerMutasi: null,
	saldoMutasi: null,
	saldoWithdraw: null,
	mutasiPagination: '',
	withdrawPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {};

const mutations = {
	setDepositResellerMutasi(state, data) {
		state.depositResellerMutasi = data.data
	},
	setSaldoDepositResellerArr(state, data) {
		state.saldoDepositResellerArr = data.data
	},
	setSaldo(state, data) {
		state.saldo = data.data
	},
	setSaldoMutasi(state, data) {
		state.saldoMutasi = data.data
	},
	setSaldoWithdraw(state, data) {
		state.saldoWithdraw = data.data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearPesanan(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getWithdrawDepositReseller({ commit }, params) {
		return new Promise((resolve) => {
			apiPenghasilan.getWithdrawDepositReseller(params).then(({ data: { data } }) => {
				commit('setSaldoWithdraw', { data: data.results });
				state.withdrawPagination = data.pagination;
				resolve(true);
			}).catch(() => {
				commit('setSaldoWithdraw', { data: [] });
			}).then(() => {
				
			});
		});
	},
	previewWithdrawDepositReseller({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPenghasilan.previewWithdrawDepositReseller(params).then((data) => {
				// dispatch('success', data.data)
				resolve(data.data.data);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	requestWithdrawDepositReseller({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPenghasilan.requestWithdrawDepositReseller(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	getSaldoSummaryDepositReseller({ commit }, params) {
		return new Promise((resolve) => {
			apiPenghasilan.getSaldoSummaryDepositReseller(params).then(({ data: { data } }) => {
				commit('setSaldoDepositResellerArr', { data: data.results });
				resolve(true);
			}).catch(() => {
				commit('setSaldoDepositResellerArr', { data: [] });
			}).then(() => {
				
			});
		});
	},
	getDepositResellerMutasi({ commit }, params) {
		return new Promise((resolve) => {
			apiPenghasilan.getDepositResellerMutasi(params).then(({ data: { data } }) => {
				commit('setDepositResellerMutasi', { data: data.results });
				state.mutasiPagination = data.pagination;
				resolve(true);
			}).catch(() => {
				commit('setDepositResellerMutasi', { data: [] });
			}).then(() => {
				
			});
		});
	},
	getSaldoSummary({ commit }, params) {
		return new Promise((resolve) => {
			apiPenghasilan.getSaldoSummary(params).then(({ data: { data } }) => {
				// console.log("data.results saldoo",data.results)
				commit('setSaldo', { data: data.results });
				resolve(true);
			}).catch(() => {
				commit('setSaldo', { data: [] });
			}).then(() => {
				
			});
		});
	},
	getSaldoMutasi({ commit }, params) {
		return new Promise((resolve) => {
			apiPenghasilan.getSaldoMutasi(params).then(({ data: { data } }) => {
				commit('setSaldoMutasi', { data: data.results });
				state.mutasiPagination = data.pagination;
				resolve(true);
			}).catch(() => {
				commit('setSaldoMutasi', { data: [] });
			}).then(() => {
				
			});
		});
	},

	getSaldoWithdraw({ commit }, params) {
		return new Promise((resolve) => {
			apiPenghasilan.getSaldoWithdraw(params).then(({ data: { data } }) => {
				commit('setSaldoWithdraw', { data: data.results });
				state.withdrawPagination = data.pagination;
				resolve(true);
			}).catch(() => {
				commit('setSaldoWithdraw', { data: [] });
			}).then(() => {
				
			});
		});
	},

	requestWithdraw({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPenghasilan.requestWithdraw(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},

	success({commit}, response) {
		commit('saveResponse', response)
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('makeAlert', { code: 'error_response', type: 'error', message: response.message, show: true }, { root: true });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};